import React from 'react';
import "../../assets/Style.css";
import waveImg from '../../assets/images/waves.png'; // this can remain as it's in src/
import Getintouch from './Getintouch';
const icons = [
  { src: process.env.PUBLIC_URL + '/images/home-icon1.png', className: 'animationicon-icon1' },
  { src: process.env.PUBLIC_URL + '/images/home-icon2.png', className: 'animationicon-icon2' },
  { src: process.env.PUBLIC_URL + '/images/home-icon3.png', className: 'animationicon-icon3' },
  { src: process.env.PUBLIC_URL + '/images/home-icon4.png', className: 'animationicon-icon4' },
  { src: process.env.PUBLIC_URL + '/images/home-icon5.png', className: 'animationicon-icon5' },
  { src: process.env.PUBLIC_URL + '/images/home-icon6.png', className: 'animationicon-icon6' },
  { src: process.env.PUBLIC_URL + '/images/home-icon7.png', className: 'animationicon-icon7' },
  { src: process.env.PUBLIC_URL + '/images/home-icon8.png', className: 'animationicon-icon8' },
  { src: process.env.PUBLIC_URL + '/images/home-icon9.png', className: 'animationicon-icon9' },
  { src: process.env.PUBLIC_URL + '/images/home-icon10.png', className: 'animationicon-icon10' },
  { src: process.env.PUBLIC_URL + '/images/home-icon11.png', className: 'animationicon-icon11' },
  { src: process.env.PUBLIC_URL + '/images/home-icon12.png', className: 'animationicon-icon12' },
  { src: process.env.PUBLIC_URL + '/images/home-icon13.png', className: 'animationicon-icon13' },
  { src: process.env.PUBLIC_URL + '/images/home-icon15.png', className: 'animationicon-icon15' },
];
const waveTexts = [
  "Website transformation for captivating appeal.",
  "Expert team revitalizes your site.",
  "Modern design and improved functionality.",
  "Enhanced user experience and navigation.",
  "Latest design trends and technologies."
];

const AnimationImage = () => {
  return (
    <section className="transform-section">
      <div className="tech-icons">
        {icons.map((icon, index) => (
          <img key={index} src={icon.src} className={icon.className} alt={`icon${index + 1}`} />
        ))}
      </div>

      <div>
        <h2 className="headline-text-h2">Give Your Site A New Look</h2>
        <p className="headline-text-p">Your website transformation partner</p>
      </div>

      <div className="wave">
        <img src={waveImg} alt="Wave Graphic" className="wave-img" />
      </div>

      <div className="wave-text">
        {waveTexts.map((text, i) => (
          <p key={i} className="wave-text-p">{text}</p>
        ))}
      </div>

    </section>
  );
};

export default AnimationImage;
